import { render, staticRenderFns } from "./LoginCardEmail.vue?vue&type=template&id=6717bf0f&scoped=true&"
import script from "./LoginCardEmail.vue?vue&type=script&lang=js&"
export * from "./LoginCardEmail.vue?vue&type=script&lang=js&"
import style0 from "./LoginCardEmail.vue?vue&type=style&index=0&id=6717bf0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717bf0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle,VForm,VSpacer,VTextField})
